import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import OutsideClickHandler from "react-outside-click-handler";

const FREQUENCIES = [
  { value: 0, label: "One Time" },
  { value: 1, label: "Weekly" },
  { value: 2, label: "Monthly" },
  { value: 3, label: "Quarterly" },
  { value: 4, label: "Semi-Annual" },
  { value: 5, label: "Annual" },
];

const FormFrequencyDropdown = ({ selectedValue, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedLabel =
    selectedValue !== "" && selectedValue !== undefined
      ? FREQUENCIES.find((f) => f.value === Number(selectedValue))?.label
      : "Select";

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative w-full">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center h-[30px] justify-between px-4 py-2 border rounded-[6px] text-gray-800 focus:outline-none focus:border-blue-500 cursor-pointer"
        >
          <span className="font-OpenSansRegular text-[12px]">{selectedLabel}</span>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {isOpen && (
          <ul className="absolute z-10 mt-2 w-full bg-white border rounded-md shadow-lg max-h-[300px] overflow-y-auto">
            {FREQUENCIES.map((freq) => (
              <li
                key={freq.value}
                onClick={() => {
                  onSelect(String(freq.value));
                  setIsOpen(false);
                }}
                className="px-4 py-1 cursor-pointer hover:bg-gray-200"
              >
                <span className="font-OpenSansRegular text-[12px]">{freq.label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default FormFrequencyDropdown;
